import { Document } from '@consigli/types';

import { DownloadFileButton } from './download-file-button';

interface DocumentCardProps {
  record: Document;
  imageSource: string;
  onClick: () => void;
}

export const DocumentCard = ({ record, imageSource, onClick }: DocumentCardProps) => (
  <div className="flex items-center py-4" key={record.id} onClick={onClick} aria-hidden="true">
    <div className="w-40 h-40 2xl:h-48 bg-white shadow-[0px_0px_20px_0px_#0000001A] px-4 py-2 rounded-lg cursor-pointer transition-shadow duration-300 hover:shadow-[0px_0px_20px_0px_#00000033] flex flex-col justify-between">
      <div className="flex justify-end">
        <DownloadFileButton document={record} className="rounded-full" size={20} />
      </div>
      <div className="h-10 flex items-center justify-center">
        <img className="h-10 w-10 object-contain" src={imageSource} alt={record.name} />
      </div>
      <div className="flex justify-between items-center 2xl:mt-2">
        <div className="break-words text-xs 2xl:text-sm line-clamp-6" title={record.name}>
          {record.name}
        </div>
      </div>
    </div>
  </div>
);
